import PropTypes from 'prop-types';
import React from 'react';
import LabreportCard from '../LabreportCard';

const LabReports = ({ labReport }) => (
  <>
    {labReport.map(({ patientId, patientName, appointments }) => (
      <div key={patientId}>
        {appointments.map(({ appointmentId, ...appointment }) => (
          <div key={appointmentId}>
            <LabreportCard
              patientName={patientName}
              patientId={patientId}
              appointment={appointment}
              labReport={labReport}
            />
          </div>
        ))}
      </div>
    ))}
  </>
);

LabReports.propTypes = {
  labReport: PropTypes.arrayOf(PropTypes.shape({
    patientId: PropTypes.string.isRequired,
    patientName: PropTypes.string.isRequired,
    appointments: PropTypes.arrayOf({})
  })),
};

LabReports.defaultProps = {
  labReport: [],
};

export default LabReports;
